module.exports = __webpack_public_path__ + "static/img/7.5f6df31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/7.png
// module id = +jlA
// module chunks = 0